import { MonthGroupedGrid } from "../../../../components/AdminList";
import type { InvoiceEntity } from "../../../../api/types";
import { groupInvoicesByMonth } from "../../../../logic/invoice-grouping";
import type { InvoiceSort } from "../types";
import { InvoiceTile } from "./InvoiceTile";

export type InvoiceTileViewProps = {
  invoices: InvoiceEntity[];
  sortBy: InvoiceSort;
  onEdit: (item: InvoiceEntity) => void;
  onView: (item: InvoiceEntity) => void;
  onViewTransactions: (item: InvoiceEntity) => void;
};

export const InvoiceTileView = ({
  invoices,
  sortBy,
  onEdit,
  onView,
  onViewTransactions,
}: InvoiceTileViewProps) => {
  const groups = groupInvoicesByMonth(invoices, sortBy);
  return (
    <MonthGroupedGrid
      groups={groups}
      getKey={(item) => item.id}
      renderItem={(item) => (
        <InvoiceTile
          item={item}
          onEdit={onEdit}
          onView={onView}
          onViewTransactions={onViewTransactions}
        />
      )}
    />
  );
};
